// import ReactDOM from "react-dom"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./containers/app/app"
import "./containers/cv-skill/themes/themeTwo/ThemeTwo.scss"
import "./containers/cv-skill/themes/themeOne/adjectif/adjectifCloud.scss"
import "./containers/cv-skill/themes/themeOne/adjectif/adjectifCv.scss"
import "./containers/cv-skill/themes/themeOne/info/infoCv.scss"
import "./containers/cv-skill/themes/themeOne/interet/interetCv.scss"
import "./containers/cv-skill/themes/themeOne/objet/objetCv.scss"
import "./containers/cv-skill/themes/themeOne/objet/radarShart.scss"
import "./containers/cv-skill/themes/themeCv.scss"
import "./resources/scss/main.scss"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"

// ReactDOM.render(
// 	<BrowserRouter>
// 		<App />
// 	</BrowserRouter>,
// 	document.getElementById("root")
// )

ReactDOM.createRoot(document.getElementById("root")!).render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
)
